import React from 'react';
import { TbX } from 'react-icons/tb';
import { Link } from 'react-router-dom';
import { SITELINK } from '../../../app-routes/Links';
import { UserInterface } from '../../../app-schemas/profile.schema';

interface WelcomeMessageProps {
  user: UserInterface;
  onClose: () => void;
}

const WelcomeMessage: React.FC<WelcomeMessageProps> = ({ user, onClose }) => {
  return (
    <section className="px-4 mt-2 bg-white w-full dark:bg-neutral-800">
      <div className="flex flex-col bg-[#004AAD] box-border shadow-sm p-3 rounded-xl">
        <div className="text-[16px] text-white gap-4 flex justify-between items-start">
          <p className="font-medium pb-0 madimi-one">Hello {user?.username ?? 'User'},</p>
          <button onClick={onClose} className='p-0 m-0'>
            <TbX />
          </button>
        </div>

        <div className="mb-5">
          <p className="text-[14px] text-white font-medium tracking-[-0.5px]">
            You have been automatically added to a community in "{user?.residency_city ?? ' '}"
            based on your profile update.{'    '}
            <Link
              className="text-white underline font-semibold"
              to={SITELINK.COMMUNITIES}
            >
              View
            </Link>
          </p>
        </div>
      </div>
    </section>
  );
};

export default WelcomeMessage;
